import React from "react";
import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Input } from "styled";
import { useCallback, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { trackSearchEvent, trackPageClickEvent, trackDownloadAndBulkUploadEvents } from "utils/analytics";
import { ANALYTICS_EVENTS } from "utils/analyticsEvents";
import ViewList from "components/cpkm/viewList";
import ReactSelect from "react-select";
import { filterSelectStyles } from "utils/reactSelectStyles";
import { TH } from "styled/table";
import { Button } from "styled";
import getFormattedDate, {getFormattedMonthYear, formatToYYYYMM, formatDateToYYYYMM} from "utils/helpers";
import { useQuery } from "react-query";
import checkPermission from "utils/checkPermission";
import permissions from "utils/permissionConstants";
import $ from "jquery";
import "jquery-ui/themes/base/all.css";
import "jquery-ui/ui/widgets/datepicker";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import BulkUpload from "components/cpkm/bulkUpload";

const CPKMUpload = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [dateFrom, setDateFrom] = useState(formatToYYYYMM(getFormattedMonthYear(new Date(new Date().getTime() - 365*24*60*60*1000))));
  const [dateTo, setDateTo] = useState(formatToYYYYMM(getFormattedMonthYear()));
  const [data, setData] = useState([]);
  const currentUser = useSelector((state) => state.user.currentUser);
  const location = useLocation();
  const [showBulkUploadModel, setShowBulkUploadModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const limit = 100;

  const getData = async (pg) => {
    setIsLoading(true);
    console.log("CALLING")
    try {
      const dt = await createDocument("/cpkm", {
        ...(selectedFleets?.includes("all")
          ? {
              fleets: getFleetOptions()
                .filter((item) => item.value !== "all" && item.value !== "clear")
                .map((item) => item.value)
                .join(","),
            }
          : selectedFleets.length && {
              fleets: selectedFleets.map((fleet) => fleet).join(","),
            }),
        ...dateFrom && {from: dateFrom},
        ...dateTo && {to: dateTo},
        limit,
        page: pg,
      });
  
      setData(dt);
      // console.log('dt', dt);
    } catch (err) {
      // console.error(err);
    } finally {
      setIsLoading(false);
    }
  };
  
  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  
  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  // useEffect(()=>{
  //   if(page !== 1) getData()
  // }, [page])

  const clickSearchBtn = () => {
    const params = {
      fleets: selectedFleets?.includes("all")
        ? "All"
        : selectedFleets?.map((id) => getFleetOptions()?.find((item) => item.value === id)?.label ?? id),
      from_date: dateFrom,
      to_date: dateTo,
    };

    trackSearchEvent(ANALYTICS_EVENTS.CLICK_SEARCH_BUTTON, "CPKM Upload", location.pathname, params);
  };

  return (
    <>
      <div>
        <div className="w-full px-8 flex justify-center items-end gap-4">
        <label className="w-full py-3 flex flex-col gap-2">
            Select Fleets
            <ReactSelect
              styles={filterSelectStyles}
              className="shadow-md rounded-md"
              options={getFleetOptions()}
              value={
                selectedFleets &&
                selectedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: getFleetOptions()?.find(
                      (item) => item?.value === fleet
                    )?.label,
                  };
                })
              }
              onChange={(value) => {
                let allValues = value?.map((item) => item.value);
                if (allValues?.includes("clear")) {
                  setSelectedFleets([]);
                  return;
                }
                if (
                  !selectedFleets?.includes("all") &&
                  allValues.includes("all")
                ) {
                  setSelectedFleets(["all"]);
                  return;
                }

                if (selectedFleets.includes("all")) {
                  value = value.filter((item) => item.value !== "all");
                }

                setSelectedFleets(value.map((fleet) => fleet.value));
              }}
              name="fleets"
              isMulti={true}
            />
          </label>
          <label className="w-full py-3 flex flex-col gap-2">
            From{" "}
            <Input
              type="month"
              id="dateFrom"
              name="dateFrom"
              max={dateTo}
              value={dateFrom}
              placeholder={"For eg- "+ getFormattedMonthYear()}
              onChange={(e) => {console.log(e.target.value);
                let month = e.target.value.split("-")[1];
                let year = e.target.value.split("-")[0];
                let today = new Date();
                let todayYear = today.getFullYear();
                let todayyMonth = today.getMonth();
                let endOfMonth = new Date(todayYear, todayyMonth + 1, 0).getTime();
                let toDate = dateTo ? new Date(dateTo.split("-")[0], dateTo.split("-")[1], 0): endOfMonth;
                console.log(dateTo)
                if(new Date(year, month, 0).getTime() > endOfMonth) return;
                if(new Date(year, month, 0).getTime() > toDate) return;
                setDateFrom(e.target.value)}} 
              />
          </label>
          <label className="w-full py-3 flex flex-col gap-2">
            To{" "}
            <Input
              type="month"
              id="dateTo"
              name="dateTo"
              max={formatDateToYYYYMM()}
              placeholder={"For eg- "+ getFormattedMonthYear()}
              min={dateFrom}
              value={dateTo}
              onChange={(e) => {console.log(e.target.value);
                let month = e.target.value.split("-")[1];
                let year = e.target.value.split("-")[0];
                let today = new Date();
                let todayYear = today.getFullYear();
                let todayyMonth = today.getMonth();
                let endOfMonth = new Date(todayYear, todayyMonth + 1, 0).getTime();
                if(new Date(year, month, 0).getTime() > endOfMonth) return;
                setDateTo(e.target.value)}} 
                           />
          </label>
          <Button
            type="button"
            className="mb-3"
            bgPrimary
            onClick={() => {
              clickSearchBtn();
              getData(page);
            }}
            disabled={!selectedFleets.length}
          >
            Search
          </Button>
          <Button
            className="mb-3 !px-8 disabled:bg-gray-400"
            bgPrimary
            disabled={
              !checkPermission(
                [permissions.upload_cpkm],
                currentUser
              )
            }
            onClick={() => {
              trackDownloadAndBulkUploadEvents(ANALYTICS_EVENTS.CLICK_BULK_UPLOAD_BUTTON, "CPKM Upload", location.pathname, { model_name: "Upload CPKM" });
              setShowBulkUploadModel(true);
            }}
          >
            Upload CPKM
          </Button>
        </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Month-Year</TH>
                      <TH scope="col">Fleet</TH>
                      <TH scope="col">Uploaded By</TH>
                      <TH scope="col">Date</TH>
                      <TH scope="col">Billed KM</TH>
                      <TH scope="col">Actions</TH>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {data &&
                      data.data &&
                      data.data?.map((item, idx) => {
                        return (
                          <ViewList
                            idx={idx}
                            data={item}
                            key={item._id}
                            page={page}
                            limit={limit}
                            getData={getData}
                          />
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
      {data && data.paginate && data.paginate.totalData && (
        <div className="container mx-auto flex justify-center items-center gap-2 py-5">
          <Button
            onClick={() => {
              trackPageClickEvent(ANALYTICS_EVENTS.CLICK_PREVIOUS_PAGE_BUTTON, "CPKM Upload", location.pathname);
              const newPage = Math.max(page - 1, 1);
              setPage(newPage);
              getData(newPage);
            }}
            disabled={page === 1}
            className="disabled:pointer-events-none disabled:opacity-70 px-0 "
            primary
          >
            <div className="flex gap-1 items-center">
              <IoMdArrowBack />
              Prev Page
            </div>
          </Button>
          <span className="text-gray-600 px-4">{`showing: ${
            (page - 1) * limit + 1
          } - ${Math.min(data?.paginate?.totalData, page * limit)} of ${
            data.paginate.totalData
          }`}</span>

          {data.paginate.totalData > page * limit && (
            <Button
              onClick={() => {
                trackPageClickEvent(ANALYTICS_EVENTS.CLICK_NEXT_PAGE_BUTTON, "CPKM Upload", location.pathname);
                const newPage = Math.min(page + 1, data?.paginate?.totalPage);
                setPage(newPage);
                getData(newPage);
              }}
              disabled={page === data?.paginate?.totalPage}
              className="disabled:pointer-events-none disabled:opacity-70 px-0 "
              primary
            >
              <div className="flex gap-1 items-center">
                Next Page
                <IoMdArrowForward />
              </div>
            </Button>
          )}
        </div>
      )}
      {showBulkUploadModel && (
        <BulkUpload handleClick={() => setShowBulkUploadModel(false)} />
      )}
    </>
  );
};

export default CPKMUpload;


